import React from 'react';
import { useSiteContent } from '../contexts/SiteContentContext';

export const Footer = () => {
  const content = useSiteContent();
  return (
    <footer id="contact" className="bg-black py-12">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex flex-col items-center justify-center space-y-6">
          <div className="text-center">
            <h3
              className="text-2xl font-black mb-2"
              style={content?.siteNameGradient ? {
                background: content.siteNameGradient,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              } : { color: content?.siteNameColor || '#FF1B6D' }}
            >
              {content?.siteName || 'zerounproduction'}
            </h3>
            <p className="text-gray-400 text-sm">
              {content?.footerTagline || 'Cultures Urbaines – Événements – Expositions'}
            </p>
          </div>

          <div className="flex items-center space-x-2 text-gray-500 text-xs">
            <span>&copy; 2026 Breakdance Crew. Tous droits réservés.</span>
          </div>

          {/* Pink Agency Badge */}
          <div className="flex items-center space-x-2 pt-4 border-t border-gray-800">
            <span className="text-gray-600 text-xs">made with ❤️ by</span>
            <a href="https://pinks-agency.fr" target="_blank" rel="noopener noreferrer" className="text-[#FF1B6D] font-bold text-xs hover:underline">Pink Agency</a>
          </div>
        </div>
      </div>
    </footer>
  );
};